import { get, post } from "../Https";

export const get2FASetups = (params: URLSearchParams) => {
  return get(`/drx/mfa/user/fetchAuthorizationSetups.do?${params}`);
};

export const startMFAEvent = (params: URLSearchParams) => {
  return get(`/drx/mfa/user/startAuthorizationEvent.do?${params}`);
};

export const complete2FAEvent = (params: URLSearchParams) => {
  return get(`/drx/mfa/user/completeAuthorizationEvent.do?${params}`);
};

export const check2FAEvent = (params: URLSearchParams) => {
  return get(`/drx/mfa/user/fetchEventStatus.do?${params}`);
};

// Get user uuid to run ID.me
export const getUserUuid = (params: any) => {
  return get("/drx/mfa/user/uuid.do?" + params);
};

// save as preference
export const saveAsPreferenceApi = (data: any) => {
  return post("/drx/api/myprofile/settings/save.do", data);
};

// get profile settings details
export const getProfileSettingsDetails = () => {
  return get("/drx/api/myprofile/settings/details.do");
};

// Delete profile settings details
export const deleteProfileSettingsDetails = (params: any) => {
  return get("/drx/api/myprofile/settings/delete.do?" + params);
};
